import { Button } from '@/components'
import GNB from '@/components/common/gnb'
import { useAxios } from '@/context/axiosContext'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { logout } from '@/redux/slices/auth'
import { useDialog } from '@/context/dialogContext'
import { LogOut } from 'react-feather'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 20px 30px;
  width: 70%;
`

const HeaderMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin-left: auto;
`

const HeaderLogo = styled.img`
  height: 40px;
  cursor: pointer;
`

const Header: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const axios = useAxios()
  const handleOnclick = () => {
    navigate('/')
  }
  const { showAlert } = useDialog()
  const handleLogout = async () => {
    try {
      await axios.post('/auth/logout')
      dispatch(logout())
      navigate('/')
    } catch (error) {
      console.error('로그아웃 실패:', error)
      showAlert({
        type: 'error',
        title: '잠시 후 다시 시도해 주세요.',
        message: '',
      })
    }
  }
  return (
    <Container>
      <HeaderMain>
        <HeaderLogo
          src="/images/logo-neverbe.png"
          alt="logo"
          onClick={handleOnclick}
        />
        <GNB />
        {isAuthenticated && (
          <Button
            height="38px"
            borderRadius="24px"
            color="white"
            onClick={handleLogout}
          >
            로그아웃
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '8px',
              }}
            >
              <LogOut size={16} />
            </span>
          </Button>
        )}
      </HeaderMain>
    </Container>
  )
}

export default Header
